import React from 'react'
import { Button } from 'react-bootstrap'
const path_image = "https://informed.pro/componentAssets/images/"

const CommonModals = ({bodyText, Buttons }) => {
  return (
    <> 
      <h4>{bodyText || ""}</h4>
      <div className="modal-buttons">
        {Buttons?.map((button, index) => (
          <Button key={index} className={button.className} onClick={button.click}>
            {button.text}
            {button.icon && <img src={path_image + button.icon} alt="" />}
          </Button>
        ))}
      </div>
      </>
  );
};


export default CommonModals